import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Text, View, StyleSheet, Image, ActivityIndicator, Platform } from 'react-native';
import { ProgramType } from 'fitbeat.models';
import Theme from '../theme';
import { Button , ButtonTypes } from '../components';
import { ChevronRightIcon } from '../ui';
import { mappedTitles } from '../WorkoutGoalAssistant/utils';
class SetupScreen extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            setupData: this.props.setupData,
            isLoading: this.props.isLoading ? this.props.isLoading : false
        }
        this.decoySetup()
    }

    decoySetup = () => {
        this.state.setupData.steps.forEach((step: any, index: number) => {
            setTimeout(() => { this.updateState(index) }, step.timeoutValue);
        })
    }

    updateState = (index: number) => {
        const setupCopy = JSON.parse(JSON.stringify(this.state.setupData))
        setupCopy.steps[index].visible = true;
        this.setState({ setupData: setupCopy })
    }

    render() {
        const {
            t,
            user,
            setupType,
            preContinueButton = null,
            buttonText = t('continue'),
            customButtonTextStyle = {}
        } = this.props;
        const { setupData } = this.state;
        const goal = user.longTermGoal || ProgramType.NotSet;
        const isSetupDone = this.state.setupData.steps[this.state.setupData.steps.length - 1].visible;
        return (
            <View style={styles.container}>
                {this.props.image}
                {setupType &&
                    <React.Fragment>
                        <Text style={styles.header}>{setupType.toUpperCase()}</Text>
                        <View style={styles.lineSeparator} />
                    </React.Fragment>
                }
                <View style={styles.fitnessGoalHeader}>
                    <Text style={styles.fitnessHeader}>FITNESS GOAL: </Text>
                    <Text style={styles.sectionHeader}>{mappedTitles[goal].toUpperCase()}</Text>
                </View>
                <View style={styles.lineSeparator} />
                <View style={{ alignSelf: 'center', marginTop: 40 }}>
                    {!isSetupDone &&
                        <React.Fragment>
                            <ActivityIndicator
                                size="large"
                                animating={!isSetupDone}
                                color={Theme.PRIMARY}
                            />
                            <Text style={styles.loadingText}>{t('personalising')}</Text>
                        </React.Fragment>
                    }
                    {isSetupDone &&
                        <React.Fragment>
                            <Image
                                resizeMode={"contain"}
                                style={styles.completeLogo}
                                source={require('../assets/images/complete-icon.png')}
                            />
                            <Text style={styles.loadingText}>{t('complete')}</Text>
                        </React.Fragment>

                    }
                </View>
                <View style={styles.setupContainer}>
                    {setupData.steps.map((step: any) => {
                        return (
                            step.visible === true &&
                            <View style={styles.descriptionContainer}>
                                <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
                                <Text style={styles.setupText}>{step.description}</Text>
                            </View>
                        )
                    })}
                </View>
                {isSetupDone &&
                    <View style={styles.footer}>
                    {preContinueButton}
                        <Button
                            fontColor={preContinueButton ? Theme.PRIMARY : Theme.WHITE}
                            isLoading={this.props.isLoading && this.props.isLoading}
                            onPress={this.props.savePreferences}
                            buttonType={preContinueButton ? ButtonTypes.TRANSPARENT : ButtonTypes.NORMAL}
                            overrideFontStyles={customButtonTextStyle}
                            title={buttonText}
                        />
                    </View>
                }
            </View>
        )
    }
}


const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 15,
        padding: 20,
        backgroundColor: 'white',
        ...Platform.select({
            web: {
                height: '100vh'
            }
        }),
    },
    sectionHeader: {
        fontSize: 20,
        color: Theme.DARK_CHARCOAL,
        fontFamily: Theme.Custom700,
        alignSelf: 'center'
    },
    fitnessHeader: {
        fontSize: 20,
        color: Theme.DARK_CHARCOAL,
        fontFamily: Theme.Custom200,
        alignSelf: 'center'
    },
    footer: {
        flex: 1,
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
    },
    descriptionContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginBottom: 10,
        alignContent: 'flex-start',
    },
    setupContainer: {
        alignSelf: 'center',
        marginBottom: 10
    },
    setupText: {
        fontFamily: Theme.Custom700,
        color: Theme.BLACK,
        lineHeight: 20,
        fontSize: 16,
        marginLeft: 15,
        marginTop: -1,
    },
    header: {
        alignSelf: 'center',
        fontSize: 24,
        fontFamily: Theme.Custom700,
        color: '#424242',
        marginBottom: 15,
        textAlign: 'center'
    },
    nutritionLogo: {
        alignSelf: 'center',
        width: 40,
        height: 40,
        margin: 2.5,
        marginHorizontal: 10,
        marginVertical: 20,
        marginTop: 50
    },
    completeLogo: {
        alignSelf: 'center',
        width: 40,
        height: 40,
    },
    goalContainer: {
        padding: 10,
        borderTopColor: '#979797',
        borderTopWidth: 1
    },
    lineSeparator: {
        height: 2,
        backgroundColor: Theme.GREY_LIGHT,
        width: '100%',
        alignSelf: 'center'
    },
    loadingText: {
        color: '#3A3A3A',
        fontSize: 18,
        fontFamily: Theme.Custom700,
        textAlign: 'center',
        marginBottom: 30,
        marginTop: 15
    },
    fitnessGoalHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginVertical: 15
    },
});

export default translate(['nutrition'], { wait: true })(SetupScreen);
